import { ExamDayType } from "./ExamDayType";
import { ExpertViewModel } from "./ExpertViewModel";
import { RoomAssignmentViewModel } from "./RoomAssignmentViewModel";
import { TimeSlotStructureType } from "./TimeSlotStructure";

export interface ExamDayViewModel {
  date: Date;
  roomAssignments: RoomAssignmentViewModel[];
  id: string;
  locationId: string;
  type: ExamDayType;
  availableUsers: ExpertViewModel[];
  availableCorrectionExperts: ExpertViewModel[];
  timeSlotStructureType: TimeSlotStructureType;
}

export function getExamIdsOfExamDay(examDay: ExamDayViewModel) {
  const examIds: string[] = [];
  examDay.roomAssignments.forEach((roomAssignment) => {
    examIds.push(...roomAssignment.examAssignments.map((examAssignment) => examAssignment.examId));
  });
  const uniqueIds = new Set(examIds);
  return Array.from(uniqueIds);
}
